var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper_out" }, [
    _c("div", { staticClass: "message_wrap" }, [
      _c("div", { staticClass: "error_msg_wrap" }, [
        _c("h4", { staticStyle: { color: "red" } }, [
          _vm._v(_vm._s(_vm.$t("cop.pm.in.title")))
        ]),
        _vm._v(" "),
        _c("h5", [
          _vm._v(
            _vm._s(
              _vm.$t("cop.pm.in.date-n-time") +
                " " +
                _vm.startDate +
                _vm.startTime +
                " - " +
                _vm.endDate +
                _vm.endTime +
                " (" +
                _vm.gmt +
                ")"
            )
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("cop.pm.in.message1")))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("cop.pm.in.message2")))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("cop.pm.in.message3")))]),
        _vm._v(" "),
        _c("p", {
          domProps: { innerHTML: _vm._s(_vm.$t("cop.pm.in.message4")) }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a37a646", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a37a646","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/maintenance/Maintenance.vue
// module id = null
// module chunks = 